export default "__VITE_ASSET__CsuP_cPN__"